<i18n
  src="@/locales/views/customer/reporting/process/list_reports.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="customer_reporting_process_list_processes_path"
    :params="{
      customer_id: customer_id,
      agro_exporter_id: agro_exporter_id
    }"
  />

  <bread-crumbs
    :labels="[module_name, agro_exporter?.name, agro_exporter_process?.name]"
  ></bread-crumbs>

  <div v-if="load_data_general" class="mt-6">
    <h1 class="page-title">
      <i class="fa-solid fa-chart-gantt"></i><span class="space-icon"></span>
      {{ $t("labels.process_reports") }}
      <span class="space-icon"></span>
    </h1>

    <div class="mt-8 flex flex-col">
      <div class="bg-white shadow overflow-hidden sm:rounded-md">
        <ul role="list" class="divide-y divide-gray-200">
          <li
            v-for="customer_report in customer_reports"
            :key="customer_report.id"
          >
            <div
              class="block hover:bg-gray-50 cursor-pointer"
              @click.prevent="showCustomerReport(customer_report)"
            >
              <div class="px-4 py-4 sm:px-6">
                <div class="flex items-center justify-between">
                  <p class="text-sm font-medium text-gray-900 truncate">
                    {{ customer_report.name }}
                  </p>
                  <div class="ml-2 flex-shrink-0 flex">
                    <a class="link invisible sm:visible">
                      <i class="fa-solid fa-eye"></i>
                      <span class="space-icon"></span>
                      {{ $t("labels.show_link") }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/customer/requesters/reporting/process/list_reports.js";

export default {
  name: "AEQualityReportsProcessListReports",
  props: ["customer_id", "agro_exporter_id", "agro_exporter_process_id"],
  data() {
    return {
      load_data_general: false,
      agro_exporter: {},
      agro_exporter_process: {}
    };
  },
  computed: {
    customer_reports() {
      return this.agro_exporter_process?.customer_reports || [];
    }
  },
  methods: {
    fetchAgroExporter: async function () {
      let response = await Requester.fetchAgroExporter(
        this.customer_id,
        this.agro_exporter_id
      );
      this.agro_exporter = response.data;
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.customer_id,
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
      this.load_data_general = true;
    },
    showCustomerReport: function (customer_report) {
      this.$router.push({
        name: "customer_reporting_process_show_report_path",
        params: {
          customer_id: this.customer_id,
          agro_exporter_id: this.agro_exporter_id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          customer_report_id: customer_report.id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          customer_id: this.customer_id
        }
      }).then(() => {
        this.fetchAgroExporter();
        this.fetchAgroExporterProcess();
      })
    );
  }
};
</script>
